import React from "react";
import Base, {Props} from "react-select/creatable";

type SelectProps = {
} & Props<{label:string, value:string}, false>;

const CreatableSelect : React.FC<SelectProps> = ({className, ...props}) =>
    <Base className={"jobjump-form-select "+className} {...props} />

export default CreatableSelect;